<template>
  <div
    ref="coverImage"
    class="w-full h-full bg-gray-200 bg-cover relative"
    :style="'background-image: url(' + coverUrl + ');'"
  >
    <div v-if="!isLink" class="absolute bottom-10 left-10">
      <DynamicHeighVideoContainer>
        <template #text>
          <div>
            <div class="text-black text-2xl bg-white/80 px-4 py-3 max-w-2xl">
              <h1 class="inline-block">Et dialogverktøy om bokvalitet</h1>
              <h2 class="mb-3">Bokvalitetsrosen er et dialogverktøy som hjelper eiendomsutviklere, arkitekter og kommuner med å definere og dokumentere bokvalitet. Målet er bedre planlegging, tydeligere forventninger og færre misforståelser</h2>
              <h2>Egner seg godt for:</h2>
              <ul class="list-disc list-inside mb-3">
                <li>Boligutviklere som vil vise kvalitetsambisjoner.</li>
                <li>Arkitekter som vil synliggjøre flere aspekter av bokvalitet.</li>
                <li>Kommuner som vurderer boligprosjekter og ønsker et strukturert grunnlag for dialog.</li>
                <li>Tverrfaglige prosjektteam med behov for et felles språk.</li>
              </ul>
              <h2>*Eies av Norsk Eiendom og Arkitektbedriftene.</h2>
            </div>
            <div class="flex h-10 mt-8" style="min-width: 20rem;">
              <img src="/img/norsk_logo.png" />
              <img src="/img/arkitekt_logo.png" class="ml-10" />
            </div>
          </div>
        </template>
        <template #video>
          <video class="w-auto" controls controlsList="nodownload">
            <source src="Bokvalitetsrosen_Demovideo.mp4" type="video/mp4">
          </video>
        </template>
      </DynamicHeighVideoContainer>
    </div>
  </div>
</template>

<script>
import DynamicHeighVideoContainer from '@/components/shared/DynamicHeighVideoContainer.vue'
import { isLinkKompassOrigin } from '@/composables/domainUtils'
export default {
  components: {
    DynamicHeighVideoContainer,
  },
  mounted () {
    if (this.$refs.coverImage) {
      this.$refs.coverImage.style.height = '100vh'
    }
  },
  computed: {
    coverUrl () {
      if (this.isLink) {
        return '/images/page_about_cover.jpg'
      }
      return '/images/page_about_cover_bokvalitet.jpg'
    },
    isLink () {
      return isLinkKompassOrigin()
    },
  },
}
</script>

<style scoped>
  h1 {
    font-size: 2rem;
    margin-bottom: 1rem;
  }
  h2 {
    @apply font-normal;
    @apply text-base;
  }
  li {
    @apply font-normal;
    @apply text-base;
    @apply ml-5;
  }
</style>
